// Product variant switcher with full page refresh
// This script handles variant selection by redirecting to the variant URL
// It expects window.theme.productHero to be set with { handle, sectionId }

(function() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSwitcher);
  } else {
    initVariantSwitcher();
  }

  function initVariantSwitcher() {
    // Check if theme namespace and config are available
    if (!window.theme || !window.theme.productHero) {
      console.error('[Variant Switcher] Missing theme.productHero config');
      return;
    }

    const { handle, sectionId } = window.theme.productHero;

    if (!handle || !sectionId) {
      console.error('[Variant Switcher] Missing required config: handle or sectionId');
      return;
    }

    // Find all variant option labels
    const optionLabels = document.querySelectorAll('.option-label');

    if (!optionLabels.length) {
      return; // No variant options on this page
    }

    // Add click listener to each label
    optionLabels.forEach(function(label) {
      label.addEventListener('click', function(e) {
        // Get the associated radio input
        const forId = this.getAttribute('for');
        const radioInput = document.getElementById(forId);

        // Skip if radio is already checked or not found
        if (!radioInput || radioInput.checked) {
          return;
        }

        // Check the radio input
        radioInput.checked = true;

        // Collect all selected option values
        const selectedOptions = [];
        const checkedRadios = document.querySelectorAll('.single-option-selector__radio:checked');

        checkedRadios.forEach(function(radio) {
          selectedOptions.push(radio.value);
        });

        // Find the master select element
        const selectElement = document.getElementById('ProductSelect--' + sectionId);

        if (!selectElement) {
          console.error('[Variant Switcher] Could not find product select element');
          return;
        }

        // Find matching variant in the select options
        let matchingVariantId = null;

        Array.from(selectElement.options).forEach(function(option) {
          // Option text contains the variant values (e.g., "30mL - $150.00 USD")
          const optionText = option.text;

          // Check if this option matches all selected values
          const matches = selectedOptions.every(function(value) {
            return optionText.includes(value);
          });

          if (matches && !option.disabled) {
            matchingVariantId = option.value;
          }
        });

        // Redirect to the variant URL
        if (matchingVariantId) {
          // Update select value for consistency
          selectElement.value = matchingVariantId;

          // Trigger change event in case other scripts are listening
          const changeEvent = new Event('change', { bubbles: true });
          selectElement.dispatchEvent(changeEvent);

          // Redirect with small delay to ensure events complete
          setTimeout(function() {
            window.location.assign('/products/' + handle + '?variant=' + matchingVariantId);
          }, 100);
        } else {
          // No matching variant found - redirect without variant parameter
          setTimeout(function() {
            window.location.assign('/products/' + handle);
          }, 100);
        }
      });
    });

    // Clean up after use to prevent namespace pollution
    delete window.theme.productHero;
  }
})();
